import { apiRequest } from './apiHelpers';

export const fetchOrganisations = async () => {
  const data = await apiRequest('/api/admin/organisations');
  return Array.isArray(data) ? data : [];
};

export const createOrganisation = ({ organisationName, organisationDomain, organisationHsaId }) =>
  apiRequest('/api/admin/neworganisation', {
    method: 'POST',
    body: JSON.stringify({ organisationName, organisationDomain, organisationHsaId }),
  });

export const updateOrganisation = (orgId, { organisationName, hsaId, organisationDomain }) =>
  apiRequest(`/api/admin/organisations/${encodeURIComponent(orgId)}`, {
    method: 'PUT',
    body: JSON.stringify({ organisationName, hsaId, organisationDomain }),
  });

export const deleteOrganisation = (orgId) =>
  apiRequest(`/api/admin/organisations/${encodeURIComponent(orgId)}`, { method: 'DELETE' });

export const updateUser = (keycloakUserId, { firstName, lastName, email }) =>
  apiRequest(`/api/admin/users/${encodeURIComponent(keycloakUserId)}`, {
    method: 'PUT',
    body: JSON.stringify({ firstName, lastName, email }),
  });

export const deleteUser = (keycloakUserId) =>
  apiRequest(`/api/admin/users/${encodeURIComponent(keycloakUserId)}`, { method: 'DELETE' });
